"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTab = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const constants_1 = require("../constants");
const ContentTabStyled = styled_components_1.default.div `
	&.content_tab {
		background: #ffffff;
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 0px 0px 1px 0px;
		padding: 12px 0px 0px 0px;
		display: flex;
		flex-direction: row;
		gap: 48px;
		align-items: center;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: sticky;
		/*
		 * 모바일/태블릿의 스크롤 컨테이너는 .container2 이고 상단 헤더(.navbar)는 그 "바깥"에 있어
		 * .container2 최상단이 이미 헤더 바로 아래다. 그런데 content_tab 은 .container2 의 첫 자식이라,
		 * top 에 헤더 높이(64px)를 주면 sticky 가 첫 자식을 그만큼 아래로 밀어 상단에 64px 흰 공백이
		 * 생긴다(헤더를 이중으로 offset). 헤더 밖 컨테이너 기준이므로 top:0 이 올바르다.
		 * (데스크탑은 스크롤 구조가 달라 헤더 높이 88.5px offset 유지)
		 */
		top: ${props => (props.$isDesktop ? '88.5px' : '0')};
		z-index: 1;

		.content-tab-item {
			flex: 1;
			padding: 0px 0px 12px 0px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;
			cursor: pointer;

			&.on {
				border-style: solid;
				border-color: var(--tur-d, #479da6);
				border-width: 0px 0px 2px 0px;

				.tab-text {
					color: var(--tur-d, #479da6);
					font-weight: var(--b4-font-weight, 700);
					font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				}
			}

			.tab-text {
				color: var(--color-black, #101010);
				text-align: center;
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}
		}
	}

	${({ $isTablet, $isMobile }) => $isMobile
    ? (0, styled_components_1.css) `
					.content-tab-item {
						.tab-text {
							font-size: var(--b4-font-size, 14px);
							line-height: var(--b4-line-height, 22px);
						}
					}
			  `
    : $isTablet
        ? (0, styled_components_1.css) `
					.content-tab-item {
						.tab-text {
							font-size: var(--b4-font-size, 14px);
							line-height: var(--b4-line-height, 22px);
						}
					}
			  `
        : (0, styled_components_1.css) `
					.content-tab-item {
						.tab-text {
							font-size: var(--b3-font-size, 16px);
							line-height: var(--b3-line-height, 32px);
						}
					}
			  `}
`;
exports.ContentTab = react_1.default.memo(({ menu, setMenu }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const handlerContentTab = (menu) => {
        setMenu(menu);
    };
    return (react_1.default.createElement(ContentTabStyled, { className: "content_tab", "$isTablet": isTablet, "$isMobile": isMobile, "$isDesktop": isDesktop }, constants_1.CONTENTS_TABS.map(tab => (react_1.default.createElement("div", { key: tab.key, className: `content-tab-item ${menu === tab.key ? 'on' : 'off'}`, onClick: () => handlerContentTab(tab.key) },
        react_1.default.createElement("p", { className: "tab-text" }, t(tab.text)))))));
});
